<ng-container *ngrxLet="vm$ as vm">
  <nty-people-toolbar [discussionsCount]="vm.totalDiscussionCount">
    <nty-toolbar-sort-btn [direction]="vm.sortDir" (sortClick)="onSortDirectionChange()">Due Date</nty-toolbar-sort-btn>
    <nty-toolbar-filter-btn id="open-discussion-filter" [active]="vm.filterIsActive" />

    @for (filterChip of vm.filterChips; track filterChip.field) {
      <terra-chip removable="true" (remove)="removeFilter(filterChip.field)">
        {{ filterChip.key }}
        @if (filterChip.value) {
          : {{ filterChip.value }}
        }
      </terra-chip>
    }
  </nty-people-toolbar>

  <nty-filter
    triggerId="open-discussion-filter"
    [formGroup]="form"
    (apply)="onApplyFilters()"
    (clear)="onClearFilters()">
    <ion-text class="terra-body ctrl-label">Person</ion-text>
    <nty-discussion-participant-select [userOptions]="vm.filterableUsers" formControlName="selectedUserId" />

    <ion-text class="terra-body ctrl-label">Show</ion-text>
    <ion-segment formControlName="showCompleted" mode="ios">
      <ion-segment-button [value]="false">
        <ion-label>Active</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="true">
        <ion-label>Complete</ion-label>
      </ion-segment-button>
    </ion-segment>
  </nty-filter>
</ng-container>
